<champs-complementaires *ngIf="isAdmin()"></champs-complementaires>
<profil-alertes-config *ngIf="canSeeAlerteConfig()"></profil-alertes-config>
<internes-params></internes-params>
<externes-params *ngIf="isAdmin()"></externes-params>

<floating-button [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
